import { useOutletContext } from 'react-router-dom'

export type PlatformOutletContext = {
  appId: number
  appKey: string
  projectId: number
  pageId: string
}

export function usePlatformOutletContext() {
  return useOutletContext<PlatformOutletContext>()
}
